<template>
  <v-row>
    <v-col cols="12" sm="10" md="5" lg="5" class="pb-0">
      <h1 class="pb-1">Смена агента</h1>
      <v-card-text class="pa-0 mb-8">
        Смена агента на домофоне, на связанных с ним ключах и абонентах, девайсе.
      </v-card-text>
      <v-form
        ref="formAgentChange"
        v-model="valid"
        lazy-validation
      >
        <v-row>
          <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
            <v-autocomplete
              label="Агент"
              :items="agents"
              v-model='agent'
              hint="При смене агента универсальные ключи нужно будет добавлять заново!"
              prepend-inner-icon="mdi-account-search"
              item-text="user.name"
              item-value="id"
              type="string"
              persistent-hint
              outlined
              dense
              flat
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <div class="my-2 mt-4">
            <v-btn
              large
              color="success"
              class="text-none"
              dark
              @click="validate()"
            >
              Активировать
            </v-btn>
            <v-btn
              large
              class="ma-2 text-none"
              outlined
              dense
              hide-details
              color="error"
              @click="cancel()"
            >
              Отменить
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-col>
    <v-col class="pb-0">
      <v-card>
        <v-card-title>
          <span>Домофоны</span>
          <v-col cols="12" sm="10" md="10" lg="9">
            <v-text-field
              v-model="filterAddress"
              @keyup="validateKeyUp"
              label="Поиск по адресу или id"
              dense
              clearable
              autocomplete="chrome-off"
              hide-details
            ></v-text-field>
          </v-col>
          <v-btn
            dark
            class="btn blue darken-3 white px-7 text-none"
            @click.prevent="filterDoorphones"
          >
            Поиск
          </v-btn>
        </v-card-title>
        <v-data-table
          class="table"
          v-model="selectedDoorphones"
          :options.sync="options"
          :server-items-length="totalDoorphones"
          :headers="headersDoorphones"
          :items="doorphones"
          item-key="id"
          show-select
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
             showFirstLastPage: true,
          }"
          :single-select="true"
          :disable-sort="true"
        >
          <template v-slot:item.address="{ item }">
            {{ item.address }}
          </template>
          <template v-slot:item.sip_status="{ item }">
            <div>
              <v-icon x-small :color="item.sip_status_color">
                mdi-checkbox-blank-circle
              </v-icon>
              {{ item.sip_status_text }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AgentChange',
  data: () => ({
    isCreated: false,
    selectedDoorphones: [],
    totalDoorphones: 0,
    filterAddress: '',
    agent: '',
    options: {
      itemsPerPage: 10,
    },
    valid: true,
    filters: { status: 'null,0,1,2,3,4,5,6,7,-1', type: 'A,M,G' },
    sort: '',
    rules: {
      required: [
        v => !!v || 'Поле обязательно для заполнения',
      ],
    },
    headersDoorphones: [
      {
        text: 'id',
        value: 'id',
      },
      {
        text: 'Адрес',
        value: 'address',
      },
      {
        text: 'Агент',
        value: 'agent',
      },
      {
        text: 'Управляющая компания',
        value: 'management_company',
      },
      {
        text: 'Статус',
        value: 'sip_status',
      },
    ],
  }),
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.isCreated = true;
    this.sort = ['-id'];
    if (Object.keys(this.$route.query).length) {
      const routeQuery = this.$route.query;

      if (routeQuery.address) {
        this.filterAddress = routeQuery.address;
        this.filters.address = routeQuery.address;
      }
    }
    this.loadDoorphones();
    // this.loadAllAgents();
  },
  computed: {
    ...mapGetters({
      doorphones: 'Doorphone/doorphones',
      agents: 'Agents/agents',
    }),
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getDoorphones',
      loadAllAgents: 'Agents/loadAllAgents',
      changeAgent: 'Doorphone/changeAgent',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    validate () {
      let doorphoneId;
      if (this.agent === '') {
        this.$flash_danger('Выберите агента');
        return;
      }
      if (!this.selectedDoorphones.length) {
        this.$flash_danger('Выберите домофон');
        return;
      } else {
        doorphoneId = this.selectedDoorphones[0].id;
      }

      this.saveAgent(doorphoneId);
    },
    saveAgent (doorphoneId) {
      this.changeAgent({
        id: doorphoneId,
        agentId: this.agent,
      }).then(() => {
        this.$flash_success('Изменения успешно сохранены');
        this.loadDoorphones();
      })
        .catch(() => {
          this.$flash_warning('Ошибка при изменении агента');
        })
        .finally(() => {
        });
    },
    cancel () {
      this.agent = null;
      this.selectedDoorphones = [];
    },
    loadDoorphones () {
      this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((response) => {
          this.totalDoorphones = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке домофонов');
        });
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { status: 'null,0,1,2,3,4,5,6,7,-1', type: 'A,M,G' };

      if (this.filterAddress) {
        if (!isNaN(this.filterAddress)) {
          this.filters.id = this.filterAddress;
          delete this.filters.address;
        } else {
          this.filters.address = this.filterAddress;
          delete this.filters.id;
        }
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
  },
};
</script>
